import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { SlArrowRight, SlArrowDown } from "react-icons/sl";
import RegisterIcon from "../../assets/icons/register.png";
import ThemeIcon from "../../assets/icons/theme.png";
import GoogleFormsIcon from "../../assets/icons/google-forms.png";
import ShareIcon from "../../assets/icons/share.png";
import DecorationImage from "../../assets/images/background-decoration.png";
import SectionHeader from "../../components/ui/HeaderSection";

const steps = [
  {
    icon: RegisterIcon,
    title: "Register",
    description:
      "Buat akun dalam hitungan detik dan mulai desain undangan pernikahanmu.",
  },
  {
    icon: ThemeIcon,
    title: "Pilih Tema",
    description:
      "Temukan tema eksklusif yang sesuai dengan gaya dan cerita cintamu.",
  },
  {
    icon: GoogleFormsIcon,
    title: "Isi Form",
    description:
      "Tambahkan detail acara dengan mudah, tanpa ribet dan langsung siap.",
  },
  {
    icon: ShareIcon,
    title: "Bagikan",
    description:
      "Kirim undangan digital ke tamu dengan sekali klik, praktis dan instan!",
  },
];

const ConvenienceSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section
      id="convenience-section"
      className="relative bg-gray-100 py-20 px-6 flex flex-col items-center text-center font-montserrat overflow-hidden"
    >
      {/* Background Decoration Left */}
      <div
        className="hidden md:block absolute inset-y-0 left-[-250px] items-center justify-center w-[600px] h-[600px] bg-no-repeat"
        style={{
          backgroundImage: `url(${DecorationImage})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
        }}
      ></div>

      {/* Background Decoration Right */}
      <div
        className="hidden md:block absolute inset-y-0 right-[-250px] items-center justify-center w-[600px] h-[600px] bg-no-repeat"
        style={{
          backgroundImage: `url(${DecorationImage})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          transform: "scaleX(-1)",
        }}
      ></div>

      {/* Title */}
      <div data-aos="fade-up" data-aos-duration="1000">
        <SectionHeader
          title="4 Langkah Mudah Buat Undangan Digital"
          description="Hanya 4 langkah, undangan digital siap dalam sekejap!"
        />
      </div>
      
      {/* Steps Container */}
      <div
        className="relative z-10 bg-white shadow-lg rounded-xl px-6 py-10 mt-8 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-6 w-full max-w-6xl"
        data-aos="zoom-in"
      >
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            {/* Step */}
            <div
              className="flex flex-col items-center text-center transition-transform duration-300 hover:-translate-y-2"
              data-aos="fade-up"
              data-aos-delay={index * 200}
            >
              <div className="flex items-center justify-center w-[70px] h-[70px] md:w-[80px] md:h-[80px] border border-gray-300 rounded-full mb-4">
                <img src={step.icon} alt={step.title} className="w-10 h-10" />
              </div>
              <h3 className="text-[#E98362] font-montserrat text-lg pb-2">
                {step.title}
              </h3>
              <p className="text-[#ABABAB] text-sm mt-2 max-w-[200px]">
                {step.description}
              </p>
            </div>

            {/* Arrow (Desktop: Right, Mobile: Down) */}
            {index < steps.length - 1 && (
              <>
                <SlArrowRight
                  className="hidden md:flex text-gray-600 text-3xl font-bold"
                  data-aos="fade-left"
                  data-aos-delay={index * 300}
                  data-aos-duration="1000"
                />
                <SlArrowDown
                  className="md:hidden flex text-gray-600 text-2xl font-bold"
                  data-aos="fade-down"
                  data-aos-delay={index * 300}
                  data-aos-duration="1000"
                />
              </>
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default ConvenienceSection;
